
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/AdminTools';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <li><a href=\"#restoreContentPane\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.admin_tools")
  },data:data},helper ? helper.call(depth0, "restore_content_4f4e7ccb", "Restore Content", options) : helperMissing.call(depth0, "t", "restore_content_4f4e7ccb", "Restore Content", options)))
    + "</a></li>\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <li class=\"notifications\"><a href=\"#commMessagesPane\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.admin_tools")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.admin_tools.view_messages", "View Notifications", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.admin_tools.view_messages", "View Notifications", options)))
    + "</a></li>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <li class=\"logging\"><a href=\"#loggingPane\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.admin_tools")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.admin_tools.tab_labels.admin_tools_logging", "Logging", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.admin_tools.tab_labels.admin_tools_logging", "Logging", options)))
    + "</a></li>\n    ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <li class=\"bouncedEmails\"><a href=\"#bouncedEmailsPane\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.admin_tools")
  },data:data},helper ? helper.call(depth0, "bounced_emails_83f293b5", "Bounced Emails", options) : helperMissing.call(depth0, "t", "bounced_emails_83f293b5", "Bounced Emails", options)))
    + "</a></li>\n    ";
  return buffer;
  }

function program9(depth0,data) {
  
  
  return "\n    <div id=\"restoreContentPane\"></div>\n    ";
  }

function program11(depth0,data) {
  
  
  return "\n    <div id=\"commMessagesPane\"></div>\n    ";
  }

function program13(depth0,data) {
  
  
  return "\n    <div id=\"loggingPane\"></div>\n    ";
  }

function program15(depth0,data) {
  
  
  return "\n    <div id=\"bouncedEmailsPane\"></div>\n    ";
  }

  buffer += "<div id=\"adminToolsTabs\">\n  <ul id=\"adminToolsTabNav\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contentRestore), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.viewMessages), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.logging), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.bouncedEmails), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </ul>\n  <div id=\"adminToolsTabPanes\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contentRestore), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.viewMessages), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.logging), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.bouncedEmails), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  